import React from 'react';

const ConsultationPage = () => {
	  return (
		      <div style={{ padding: '100px 20px', textAlign: 'center' }}>
		        <h1>Schedule a Consultation</h1>
		        <p>Book a meeting with our experts.</p>
		      </div>
		    );
};

export default ConsultationPage;
